import { useCallback, useEffect, useRef, useState } from 'react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { useLazyGetIntegrationFeatureFlagsForPartyQuery } from './contabilCompanyLinkFeatureFlagsApi';
import { isPlatformAccountantIntegrationSgdActive } from './contabilCompanyLinkFlow';
export function usePlatformAccountantIntegrationSgdAccess() {
    const [fetchFeatureFlagsForParty] = useLazyGetIntegrationFeatureFlagsForPartyQuery();
    const [gateResolution, setGateResolution] = useState('pending');
    const syncGenerationRef = useRef(0);
    const partyId = getSelectedAccountInfo()?.partyId ?? '';
    const resolveGateFromRemoteFlags = useCallback(async () => {
        if (!partyId) {
            setGateResolution('disabled');
            return false;
        }
        const flags = await fetchFeatureFlagsForParty({ partyId }).unwrap();
        const isActive = isPlatformAccountantIntegrationSgdActive(flags);
        setGateResolution(isActive ? 'enabled' : 'disabled');
        return isActive;
    }, [partyId, fetchFeatureFlagsForParty]);
    const refreshAndCheckEnabled = useCallback(async () => {
        return resolveGateFromRemoteFlags();
    }, [resolveGateFromRemoteFlags]);
    useEffect(() => {
        if (!partyId) {
            setGateResolution('disabled');
            return;
        }
        const generation = ++syncGenerationRef.current;
        void (async () => {
            try {
                const flags = await fetchFeatureFlagsForParty({ partyId }).unwrap();
                if (generation !== syncGenerationRef.current) {
                    return;
                }
                const isActive = isPlatformAccountantIntegrationSgdActive(flags);
                setGateResolution(isActive ? 'enabled' : 'disabled');
            }
            catch {
                if (generation === syncGenerationRef.current) {
                    setGateResolution('disabled');
                }
            }
        })();
    }, [partyId, fetchFeatureFlagsForParty]);
    const isResolvingGate = gateResolution === 'pending' && !!partyId;
    return {
        isEnabled: gateResolution === 'enabled',
        isLoading: isResolvingGate,
        isReady: !isResolvingGate,
        refreshAndCheckEnabled,
    };
}
